module.exports = __webpack_public_path__ + "static/media/no-share-arrow.099728a4.png";